import React, { useContext, useEffect, useState } from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { Label } from "reactstrap";
import Header from "../../../../components/Header";
import { UserConsumer, UserContext } from "../../../../UserContext";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import PageLoader from "../../../../components/PageLoader";
import { Routes } from "../../../../configurations/config";

function VendorContact() {
	const history = useHistory();
	const { vendorId } = useParams();
	const { token } = useContext(UserContext);
	const [vendorDetails, setVendorDetails] = useState(null);
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionVendor}/${vendorId}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setVendorDetails(res.data);
				setLoading(false);
			});
	}, [vendorId]);
	return (
		<UserConsumer>
			{(userDetails) => {
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					loading ? (
						<PageLoader />
					) : (
						<>
							<div className="container-fluid pl-3 pr-3 pt-2">
								<Header
									title="Vendor Contact"
									headerBorder="true"
									navigateBack={() =>
										history.push(
											Routes.ItemRequisitionVendors
										)
									}
								/>
								<div className="formInfoContainer mt-3">
									<div className="formInfoContainerHeader">
										<Label sm={12}>
											Vendor Contact Details
										</Label>
									</div>
									<Col>
										<Row
											style={{
												padding: "10px 50px 10px 50px",
											}}
										>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Name:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{vendorDetails?.name}
												</p>
											</Col>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Primary Contact:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{
														vendorDetails?.primaryContact
													}
												</p>
											</Col>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Phone:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{vendorDetails?.phone}
												</p>
											</Col>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Phone2:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{vendorDetails?.phone2
														? vendorDetails?.phone2
														: "NA"}
												</p>
											</Col>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Email:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{vendorDetails?.email}
												</p>
											</Col>
											<Col md={12} lg={2}>
												<div className="formDetailHeader">
													<div>Address:</div>
												</div>
											</Col>
											<Col md={12} lg={4}>
												<p className="formValueContainer">
													{vendorDetails?.address
														? vendorDetails?.address
														: "NA"}
												</p>
											</Col>
										</Row>
									</Col>
								</div>
							</div>
						</>
					)
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default VendorContact;
